export default class Exercise {
    decimalTask = 0;
    convertedTask = "";
    result = [];

    /**
     *
     * @param {Number[]} decimalTask
     * @param {String[]} convertedTask
     * @param {ResultItem[]} result
     */
    constructor(decimalTask, convertedTask, result){
        this.decimalTask = decimalTask;
        this.convertedTask = convertedTask;
        this.result = result;
    }

    getTask = () => {
        return this.convertedTask;
    };

    getFinalResult = () => {
        return this.result[this.result.length-1];
    };

    getResultAtIndex = (index) =>{
        return this.result[index];
    };

    getStepCount = () => {
        return this.result.length;
    }
}